<div class="license-wrapper border-box">
    <p-accordion class="custom-accordion">

        <p-accordionTab [header]="'LEA Data Templates'">

            <div class="actions-bar">

                <div class="lea-temp-container" *ngIf="showLeacreatetemplate">
                    <div class="field-wrapper">
                        <label class="field-label">
                            Select Template<span class="required">*</span>  
                        </label>
                        <!-- <p-dropdown [options]="templateLeaHistoryData" placeholder="Select Template Type"
                            [autoDisplayFirst]="false" optionLabel="template_name" optionValue="template_id"
                            [filter]="true" filterBy="value" [showClear]="true" [(ngModel)]="portaltype"
                            (onChange)="getLeaTemplateColumns($event)">
                        </p-dropdown> -->
                        <div style="width:225.7px"
                            [matTooltip]="getLongLabel(selectedTemplate?.template_name)"
                            matTooltipPosition="above"
                            matTooltipClass="custom-tooltip">
                            <p-dropdown [options]="templateLeaDropdownData" placeholder="Select Template Type"
                                [autoDisplayFirst]="false" optionLabel="template_name" [filter]="true"
                                filterBy="template_name" [showClear]="false" [(ngModel)]="selectedTemplate"
                                (onChange)="getLeaTemplateColumns($event)" styleClass="select-template-custom-dropdown">
                            </p-dropdown>
                        </div>
                          <span class="text-danger mt-1 err-font" *ngIf="selectedTemplate?.template_id == undefined && btnclicked">
                                {{lookupErrorMessages?.['M0189']}}
                            </span>           
                        
                    </div>
                    <!-- <div class="d-flex justify-content-end eppdataactioncancel pl-3 mt-3">
                        <button class="btn-cancel btn text-right py-1 height_btn"  (click)="resetTemplateLeaColumns()" >Cancel</button>
                    </div> -->
                    <div class="transfer-container">
                        <div class="panel">
                            <h3 class="panel-title">Available Fields</h3>
                            <ul class="field-list">
                                <li class="field-item" *ngFor="let field of availableFieldsLea">
                                    <button class="icon-btn add" (click)="addFieldLea(field)">
                                        <span class="icon-btn-title">{{ field.data_ele_name }}</span>

                                        <span class="material-symbols-outlined">
                                            trending_flat
                                        </span>
                                    </button>
                                </li>
                            </ul>
                        </div>

                        <div class="panel-wrapper">
                            <div class="panel">
                                <h3 class="panel-title">Selected Fields<span class="required">*</span></h3>
                                <ul class="field-list">
                                    <li class="field-item" *ngFor="let field of selectedFieldsLea">
                                        <button class="icon-btn remove" (click)="removeFieldLea(field)">
                                            <span class="icon-btn-title">{{ field.data_ele_name }}</span>
                        
                                            <span class="material-symbols-outlined">
                                                close
                                            </span>
                                        </button>
                                    </li>
                                </ul>
                        
                            </div>
                            <span class="text-danger mt-2 err-font" *ngIf="selectedFieldsLea.length == 0 && btnclicked">
                                {{lookupErrorMessages?.['M0190']}}
                            </span>
                        </div>
 

                    </div>

                    <div class="field-wrapper mt-">
                        <label class="field-label">
                            Template Name<span class="required">*</span>
                        </label>
                        <input pInputText class="form-control template_input" placeholder="Enter"
                            [(ngModel)]="template_name"  (keypress)="allowOnlyValidChars($event)"
  (paste)="handlePaste($event)" />
                            <span class="text-danger mt-1 err-font" *ngIf="template_name == '' && btnclicked">
                                {{lookupErrorMessages?.['M0187']}}
                            </span>                           
                    </div>

                    <div class="d-flex justify-content-end eppdataactionscancel pl-3 mt-3">
                        <button *ngIf="!editbtn" pButton type="button" label="Cancel" class="p-mt-3 btn-cancel"
                            (click)="resetTemplateLeaColumns()">
                        </button>
                        <button *ngIf="editbtn" pButton type="button" label="Reset" class="p-mt-3 btn-cancel"
                            (click)="resetTemplateLeaColumns()">
                        </button>
                        <button pButton type="button" *ngIf="!editbtn" label="Save" class="p-mt-3"
                            (click)="saveTemplateLeaColumns()">
                        </button>
                        <button pButton type="button" *ngIf="editbtn" label="Update" class="p-mt-3"
                            (click)="editTemplateLeaColumns()">
                        </button>
                    </div>
                </div>

                <div class="leadata-grid-table-container"
                    [ngClass]="{ 'leadata-grid-table-top': showLeacreatetemplate }">
                    <h5 *ngIf="showLeacreatetemplate" class="leadatatitle"> LEA Data Templates </h5>

                    <div class="d-flex justify-content-end mb-3">
                        <button pButton type="button" *ngIf="!showLeacreatetemplate" label="Update Template"
                             (click)="createLeaTemplate()">
                        </button>
                    </div>

                    <dx-data-grid #dataGrid [dataSource]="templateLeaHistoryData" [showBorders]="true"
                        [rowAlternationEnabled]="true" [columnAutoWidth]="true" [wordWrapEnabled]="true"
                        [allowColumnResizing]="true" [columnResizingMode]="'widget'"
                        (onContentReady)="setActionColumnWidth($event)" (onEditorPrepared)="onEditorPrepared($event)">

                        <dxo-filter-row [visible]="true" [applyFilter]="'auto'"></dxo-filter-row>
                        <dxo-header-filter [visible]="true"></dxo-header-filter>
                        <dxo-paging [pageSize]="currentPageSize"></dxo-paging>
                        <dxo-pager [visible]="true" [allowedPageSizes]="[10, 25, 50, 100]" [displayMode]="displayMode"
                            [showPageSizeSelector]="true" [showInfo]="true" [showNavigationButtons]="true"></dxo-pager>
                        <dxo-sorting mode="multiple"></dxo-sorting>

                        <ng-container *ngFor="let column of templateLeagridConfig; let i = index">
                            <ng-container *ngIf="column.hide !== true">
                                <ng-container *ngIf="column.link; else noLink">
                                    <dxi-column [dataField]="column.columnDef" [caption]="column.header"
                                        [allowFiltering]="column.filter" cellTemplate="cellTemplate"></dxi-column>
                                </ng-container>
                                <ng-template #noLink>
                                    <ng-container *ngIf="column.icon; else noIcon">
                                        <dxi-column [dataField]="column.columnDef" [caption]="column.header"
                                            [allowFiltering]="column.filter" cellTemplate="iconTemplate"></dxi-column>
                                    </ng-container>
                                </ng-template>
                                <!-- <ng-template #noIcon>
                                <ng-container *ngIf="column.dateFormat; else noDate">
                                    <dxi-column *ngIf="column.dateFormat === 'date' || column.dateFormat === 'datetime'"
                                        [dataField]="column.columnDef" [caption]="column.header"
                                        [allowFiltering]="column.filter" [dataType]="'date'" format="MM/dd/yyyy">
                                    </dxi-column>
                                </ng-container>
                            </ng-template>
                            <ng-template #noBadge>
    <ng-container *ngIf="column.badge; else noDate">
        <dxi-column [dataField]="column.columnDef" [caption]="column.header"
            [allowFiltering]="column.filter" cellTemplate="badgeTemplate">
        </dxi-column>
    </ng-container>
</ng-template>
                            <ng-template #noDate>
                                <dxi-column [dataField]="column.columnDef" [caption]="column.header"
                                    [allowFiltering]="column.filter">
                                </dxi-column>
                            </ng-template> -->
                                <ng-template #noIcon>
                                    <ng-container *ngIf="column.dateFormat; else noBadge">
                                        <dxi-column
                                            *ngIf="column.dateFormat === 'date' || column.dateFormat === 'datetime'"
                                            [dataField]="column.columnDef" [caption]="column.header"
                                            [allowFiltering]="column.filter" [dataType]="'date'" format="MM/dd/yyyy"
                                            [editorOptions]="{ type: 'date', inputAttr: { 'aria-label': column.header }}">
                                        </dxi-column>
                                    </ng-container>
                                    <ng-template #noBadge>
                                        <ng-container *ngIf="column.badge; else noDate">
                                            <dxi-column [dataField]="column.columnDef" [caption]="column.header"
                                                [allowFiltering]="column.filter" cellTemplate="badgeTemplate">
                                            </dxi-column>
                                        </ng-container>
                                        <ng-template #noDate>
                                            <dxi-column [dataField]="column.columnDef" [caption]="column.header"
                                                [allowFiltering]="column.filter">
                                            </dxi-column>
                                        </ng-template>
                                    </ng-template>
                                </ng-template>
                            </ng-container>
                        </ng-container>
                        <dxi-column *ngIf="isVisible || isActionVisible" caption="Actions" [width]="actionColumnWidth"
                            [allowSorting]="false" cellTemplate="actionsTemplate"></dxi-column>

                        <div *dxTemplate="let data of 'actionsTemplate'" class="leadatactioncontainer">
                            <button class="action-icon-button"
                                [ngStyle]="{ 'display': (isShowEdit === true) ? 'flex' : 'none' }"
                                pTooltip="Edit" tooltipPosition="top" tooltipStyleClass="pcustom-tooltip" (click)="onLeaEdit(data)">
                                <span class="sr-only">Edit</span>
                                <span class="material-symbols-outlined">edit_square</span>
                            </button>
                            <button class="action-icon-button download-btn" pTooltip="Download" tooltipPosition="top" tooltipStyleClass="pcustom-tooltip"
                                (click)="onDownloadTemplate(data)">
                                <span class="material-symbols-outlined material-delete-symbol">download</span>
                            </button>
                            <button class="action-icon-button activate-btn" pTooltip="Activate"
                                *ngIf="data.data?.template_status == 'INACTIVE'" tooltipPosition="top" tooltipStyleClass="pcustom-tooltip"
                                (click)="activateLeaTemplatePopup(data,deleteModel)">
                                <span class="material-symbols-outlined">check_circle</span>
                            </button>

                            <button class="action-icon-button deletebtn" pTooltip="Deactivate"
                                *ngIf="data.data?.template_status == 'ACTIVE'" tooltipPosition="top" tooltipStyleClass="pcustom-tooltip"
                                (click)="deactivateLeaTemplatePopup(data,deleteModel1)">
                                <span class="material-symbols-outlined">unpublished</span>
                            </button>
                            <button class="action-icon-button deletebtn" *ngIf="data.data?.errorcount == null && data.data?.base_template !== 'Base'"
                                [ngStyle]="{ 'display': (isShowDelete === true) ? 'flex' : 'none' }"
                                pTooltip="Delete" tooltipPosition="top" tooltipStyleClass="pcustom-tooltip" (click)="onDelete(data, deleteModel2)">
                                <span class="sr-only">Delete</span>
                                <span class="material-symbols-outlined material-delete-symbol">delete</span>
                            </button>

                        </div>
                        <div *dxTemplate="let d of 'cellTemplate'">
                            <span href="javascript:void(0)" *ngIf="d.value && d.value !== 'null'" class="link-data"
                                (click)="getRouter(d)">{{
                                d.value !== 'null' ? d.value : ''
                                }}</span>
                        </div>
                        <div *dxTemplate="let d of 'badgeTemplate'">
                            <span class="status-badge" [ngClass]="{
                        'badge-active': d.value?.toLowerCase() === 'active',
                        'badge-inactive': d.value?.toLowerCase() === 'inactive',
                    }">
                                <span class="dot"></span>
                                {{ formatStatusText(d.value) }}
                            </span>
                        </div>
                        <ng-container>
                            <div *dxTemplate="let d of 'cellTemplate'">
                                <span *ngIf="d.value && d.value !== 'null'" #contentWrapper
                                    [innerHTML]="d.value | safeHtml">{{
                                    d.value !== 'null' ? d.value : ''
                                    }}</span>
                            </div>
                        </ng-container>
                        <div *dxTemplate="let d of 'iconTemplate'">
                            <em class="fa fa-book"></em>
                        </div>
                    </dx-data-grid>
                </div>
            </div>


        </p-accordionTab>

    </p-accordion>

    <p-accordion class="custom-accordion">

        <p-accordionTab [header]="'EPP Data Templates'">

            <div class="actions-bar">

                <div class="epp-temp-container" *ngIf="showEppcreatetemplate">
                    <div class="field-wrapper">
                        <label class="field-label">
                            Select Template<span class="required">*</span>
                        </label>
                        <!-- <p-dropdown [options]="templateEppHistoryData" placeholder="Select Template Type"
                            [autoDisplayFirst]="false" optionLabel="template_name" optionValue="template_id"
                            [filter]="true" filterBy="value" [showClear]="true" [(ngModel)]="portaltype"
                            (onChange)="getEppTemplateColumns($event.value)">
                        </p-dropdown> -->

                        <div style="width:225.7px"
                            [matTooltip]="getLongLabel(selectedTemplateEpp?.template_name)"
                            matTooltipPosition="above"
                            matTooltipClass="custom-tooltip">
                            <p-dropdown [options]="templateEppDropdownData" placeholder="Select Template Type"
                                [autoDisplayFirst]="false" optionLabel="template_name" [filter]="true"
                                filterBy="template_name" [showClear]="false" [(ngModel)]="selectedTemplateEpp"
                                (onChange)="getEppTemplateColumns($event)" (onClear)="onDropdownClear()" styleClass="select-template-custom-dropdown">
                            </p-dropdown>
                        </div>

                    </div>
                    <!-- <div class="d-flex justify-content-end eppdataactioncancel pl-3 mt-3">
                        <button class="btn-cancel btn text-right py-1 height_btn">Cancel</button>
                    </div> -->
                    <div class="transfer-container">
                                                <div class="panel">
                            <h3 class="panel-title">Available Fields</h3>
                            <ul class="field-list">
                                <li class="field-item" *ngFor="let field of availableFieldsEpp">
                                    <button class="icon-btn add" (click)="addFieldEpp(field)">
                                        <span class="icon-btn-title">{{field.data_ele_name}}</span>

                                        <span class="material-symbols-outlined">
                                            trending_flat
                                        </span>
                                    </button>
                                </li>
                            </ul>
                        </div>
                        <div class="panel-wrapper">
                        


                        <div class="panel">
                            <h3 class="panel-title">Selected Fields<span class="required">*</span></h3>
                            <ul class="field-list">
                                <li class="field-item" *ngFor="let field of selectedFieldsEpp">
                                    <button class="icon-btn remove" (click)="removeFieldEpp(field)">
                                        <span class="icon-btn-title">{{field.data_ele_name}}</span>

                                        <span class="material-symbols-outlined">
                                            close
                                        </span>
                                    </button>
                                </li>
                            </ul>
                        </div>
                            <span class="text-danger mt-2 err-font" *ngIf="selectedFieldsEpp.length == 0 && btnclicked">
                                {{lookupErrorMessages?.['M0190']}}
                            </span>
                        </div>
                    </div>

                    <div class="field-wrapper mt-">
                        <label class="field-label">
                            Template Name<span class="required">*</span>
                        </label>
                        <input pInputText class="form-control template_input" placeholder="Enter"
                            [(ngModel)]="template_name_epp" (keypress)="allowOnlyValidChars($event)"
  (paste)="handlePaste($event)" />
                        <span class="text-danger mt-1 err-font" *ngIf="template_name_epp == '' && btnclicked">
                            {{lookupErrorMessages?.['M0187']}}
                        </span>
                    </div>


                    <div class="d-flex justify-content-end eppdataactionscancel pl-3 mt-3">
                        <button pButton type="button" *ngIf="!editbtn" label="Cancel" class="p-mt-3 btn-cancel"
                            (click)="resetTemplateEppColumns()">
                        </button>
                        <button pButton type="button" *ngIf="editbtn" label="Reset" class="p-mt-3 btn-cancel"
                            (click)="resetTemplateEppColumns()">
                        </button>
                        <button pButton type="button" *ngIf="!editbtn" label="Save" class="p-mt-3"
                            (click)="saveTemplateEppColumns()">
                        </button>
                        <button pButton type="button" *ngIf="editbtn" label="Update" class="p-mt-3"
                            (click)="editTemplateEppColumns()">
                        </button>
                    </div>

                </div>
                <div class="leadata-grid-table-container"
                    [ngClass]="{ 'leadata-grid-table-top': showEppcreatetemplate }">
                    <h5 *ngIf="showEppcreatetemplate" class="leadatatitle"> EPP Data Templates </h5>
                    <div class="d-flex justify-content-end mb-3">
                        <button pButton type="button" *ngIf="!showEppcreatetemplate" label="Update Template"
                             class="p-mt-3" (click)="createEPPTemplate()">
                        </button>
                    </div>
                    <dx-data-grid #dataGrid [dataSource]="templateEppHistoryData" [showBorders]="true"
                        [rowAlternationEnabled]="true" [columnAutoWidth]="true" [wordWrapEnabled]="true"
                        [allowColumnResizing]="true" [columnResizingMode]="'widget'"
                        (onContentReady)="setActionColumnWidth($event)" (onEditorPrepared)="onEditorPrepared($event)">

                        <dxo-filter-row [visible]="true" [applyFilter]="'auto'"></dxo-filter-row>
                        <dxo-header-filter [visible]="true"></dxo-header-filter>
                       <dxo-paging [pageSize]="currentPageSize"></dxo-paging>
                        <dxo-pager [visible]="true" [allowedPageSizes]="[10, 25, 50, 100]" [displayMode]="displayMode"
                            [showPageSizeSelector]="true" [showInfo]="true" [showNavigationButtons]="true"></dxo-pager>
                        <dxo-sorting mode="multiple"></dxo-sorting>

                        <ng-container *ngFor="let column of templateEppgridConfig; let i = index">
                            <ng-container *ngIf="column.hide !== true">
                                <ng-container *ngIf="column.link; else noLink">
                                    <dxi-column [dataField]="column.columnDef" [caption]="column.header"
                                        [allowFiltering]="column.filter" cellTemplate="cellTemplate"></dxi-column>
                                </ng-container>
                                <ng-template #noLink>
                                    <ng-container *ngIf="column.icon; else noIcon">
                                        <dxi-column [dataField]="column.columnDef" [caption]="column.header"
                                            [allowFiltering]="column.filter" cellTemplate="iconTemplate"></dxi-column>
                                    </ng-container>
                                </ng-template>
                                <!-- <ng-template #noIcon>
                                <ng-container *ngIf="column.dateFormat; else noDate">
                                    <dxi-column *ngIf="column.dateFormat === 'date' || column.dateFormat === 'datetime'"
                                        [dataField]="column.columnDef" [caption]="column.header"
                                        [allowFiltering]="column.filter" [dataType]="'date'" format="MM/dd/yyyy">
                                    </dxi-column>
                                </ng-container>
                            </ng-template>
                            <ng-template #noDate>
                                <dxi-column [dataField]="column.columnDef" [caption]="column.header"
                                    [allowFiltering]="column.filter">
                                </dxi-column>
                            </ng-template> -->
                                <ng-template #noIcon>
                                    <ng-container *ngIf="column.dateFormat; else noBadge">
                                        <dxi-column
                                            *ngIf="column.dateFormat === 'date' || column.dateFormat === 'datetime'"
                                            [dataField]="column.columnDef" [caption]="column.header"
                                            [allowFiltering]="column.filter" [dataType]="'date'" format="MM/dd/yyyy">
                                        </dxi-column>
                                    </ng-container>
                                    <ng-template #noBadge>
                                        <ng-container *ngIf="column.badge; else noDate">
                                            <dxi-column [dataField]="column.columnDef" [caption]="column.header"
                                                [allowFiltering]="column.filter" cellTemplate="badgeTemplate">
                                            </dxi-column>
                                        </ng-container>
                                        <ng-template #noDate>
                                            <dxi-column [dataField]="column.columnDef" [caption]="column.header"
                                                [allowFiltering]="column.filter">
                                            </dxi-column>
                                        </ng-template>
                                    </ng-template>
                                </ng-template>
                            </ng-container>
                        </ng-container>
                        <dxi-column *ngIf="isVisible || isActionVisible" caption="Actions" [width]="actionColumnWidth"
                            [allowSorting]="false" cellTemplate="actionsTemplate"></dxi-column>

                        <div *dxTemplate="let data of 'actionsTemplate'" class="leadatactioncontainer">
                            <button class="fa fa-edit action-icon-button"
                                [ngStyle]="{ 'display': (isShowEdit === true) ? 'inline-block' : 'none' }"
                                pTooltip="Edit" tooltipPosition="top" tooltipStyleClass="pcustom-tooltip" (click)="onEppEdit(data)">
                                <span class="sr-only">Edit</span>
                            </button>
                            <button class="action-icon-button download-btn" pTooltip="Download" tooltipPosition="top" tooltipStyleClass="pcustom-tooltip"
                                (click)="onDownloadTemplate(data)">
                                <span class="material-symbols-outlined">download</span>
                            </button>
                            <button class="action-icon-button activate-btn" pTooltip="Activate"
                                *ngIf="data.data?.template_status == 'INACTIVE'" tooltipPosition="top" tooltipStyleClass="pcustom-tooltip"
                                (click)="activateEppTemplatePopup(data,deleteModelEpp)">
                                <span class="material-symbols-outlined">check_circle</span>
                            </button>

                            <button class="action-icon-button deletebtn" pTooltip="Deactivate"
                                *ngIf="data.data?.template_status == 'ACTIVE'" tooltipPosition="top" tooltipStyleClass="pcustom-tooltip"
                                (click)="deactivateEppTemplatePopup(data, deleteModel1Epp)">
                                <span class="material-symbols-outlined">unpublished</span>
                            </button>
                            <!-- <button class="fa fa-trash action-icon-button deletebtn"
                                [ngStyle]="{ 'display': (isShowDelete === true) ? 'inline-block' : 'none' }"
                                pTooltip="Delete" tooltipPosition="bottom" (click)="onLicRequirementDelete(data, deleteModel)">
                                <span class="sr-only">Delete</span>
                            </button> -->

                             <button class="action-icon-button deletebtn" *ngIf="data.data?.errorcount == null && data.data?.base_template !== 'Base'"
                                [ngStyle]="{ 'display': (isShowDelete === true) ? 'inline-block' : 'none' }"x
                                pTooltip="Delete" tooltipPosition="top" tooltipStyleClass="pcustom-tooltip" (click)="onDelete(data, deleteModel2)">
                                <span class="sr-only">Delete</span>
                                <span class="material-symbols-outlined material-delete-symbol">delete</span>
                            </button>

                        </div>
                        <div *dxTemplate="let d of 'cellTemplate'">
                            <span href="javascript:void(0)" *ngIf="d.value && d.value !== 'null'" class="link-data"
                                (click)="getRouter(d)">{{
                                d.value !== 'null' ? d.value : ''
                                }}</span>
                        </div>
                        <div *dxTemplate="let d of 'badgeTemplate'">
                            <span class="status-badge" [ngClass]="{
                        'badge-active': d.value?.toLowerCase() === 'active',
                        'badge-inactive': d.value?.toLowerCase() === 'inactive',
                    }">
                                <span class="dot"></span>
                                {{ formatStatusText(d.value) }}
                            </span>
                        </div>
                        <ng-container>
                            <div *dxTemplate="let d of 'cellTemplate'">
                                <span *ngIf="d.value && d.value !== 'null'" #contentWrapper
                                    [innerHTML]="d.value | safeHtml">{{
                                    d.value !== 'null' ? d.value : ''
                                    }}</span>
                            </div>
                        </ng-container>
                        <div *dxTemplate="let d of 'iconTemplate'">
                            <em class="fa fa-book"></em>
                        </div>
                    </dx-data-grid>
                </div>
            </div>


        </p-accordionTab>

    </p-accordion>

    <p-accordion class="custom-accordion">

        <p-accordionTab [header]="'EPP Reference Documents'">

            <div class="actions-bar">
                <div class="leadata-grid-table-container">

                    <div class="row row-alignment">
                        <button type="button" class="btn btn-primary grid rounded upload-btn mr-2" style="margin-right: 8px;"
                                (click)="showEppRefDocUploadModal(eppRefDocUploadModel)">
                            <img class="mr-2 width-20" src="../../../../assets/images/neveda-images/upload.svg"
                                 alt="" srcset="">Upload
                        </button>

                        <div class="queues-export-btn-group">
                            <button  aria-label="Export" mat-icon-button class="icon-btn" pTooltip="Export" tooltipPosition="top"
                                    tooltipStyleClass="pcustom-tooltip" (click)="exportEppRefDocs()">
                                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none">
                                    <path d="M12 15.4115C11.8795 15.4115 11.7673 15.3923 11.6635 15.3538C11.5597 15.3154 11.4609 15.2494 11.3672 15.1558L8.25775 12.0463C8.10908 11.8974 8.03567 11.7233 8.0375 11.524C8.0395 11.3247 8.11292 11.1474 8.25775 10.9922C8.41292 10.8373 8.59108 10.7572 8.79225 10.752C8.99358 10.7468 9.17183 10.8218 9.327 10.977L11.25 12.9V5.25C11.25 5.03717 11.3218 4.859 11.4655 4.7155C11.609 4.57183 11.7872 4.5 12 4.5C12.2128 4.5 12.391 4.57183 12.5345 4.7155C12.6782 4.859 12.75 5.03717 12.75 5.25V12.9L14.673 10.977C14.8218 10.8283 14.9984 10.7549 15.2028 10.7568C15.4072 10.7588 15.5871 10.8373 15.7423 10.9922C15.8871 11.1474 15.9621 11.3231 15.9672 11.5192C15.9724 11.7154 15.8974 11.8911 15.7423 12.0463L12.6328 15.1558C12.5391 15.2494 12.4403 15.3154 12.3365 15.3538C12.2327 15.3923 12.1205 15.4115 12 15.4115ZM6.30775 19.5C5.80258 19.5 5.375 19.325 5.025 18.975C4.675 18.625 4.5 18.1974 4.5 17.6923V15.7308C4.5 15.5179 4.57183 15.3398 4.7155 15.1962C4.859 15.0526 5.03717 14.9808 5.25 14.9808C5.46283 14.9808 5.641 15.0526 5.7845 15.1962C5.92817 15.3398 6 15.5179 6 15.7308V17.6923C6 17.7692 6.03208 17.8398 6.09625 17.9038C6.16025 17.9679 6.23075 18 6.30775 18H17.6923C17.7692 18 17.8398 17.9679 17.9038 17.9038C17.9679 17.8398 18 17.7692 18 17.6923V15.7308C18 15.5179 18.0718 15.3398 18.2155 15.1962C18.359 15.0526 18.5372 14.9808 18.75 14.9808C18.9628 14.9808 19.141 15.0526 19.2845 15.1962C19.4282 15.3398 19.5 15.5179 19.5 15.7308V17.6923C19.5 18.1974 19.325 18.625 18.975 18.975C18.625 19.325 18.1974 19.5 17.6923 19.5H6.30775Z" fill="currentColor" />
                                </svg>
                            </button>
                        </div>

                        <div class="queues-column-chooser-group" style="margin-right: 8px;">
                            <button  aria-label="Column Chooser" mat-icon-button class="icon-btn" pTooltip="Column Chooser" tooltipPosition="top"
                                    tooltipStyleClass="pcustom-tooltip" (click)="toggleEppRefDocColumnChooser()">
                                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none">
                                    <path d="M4.30775 18H8.3365V6H4.30775C4.21792 6 4.14417 6.02883 4.0865 6.0865C4.02883 6.14417 4 6.21792 4 6.30775V17.6923C4 17.7821 4.02883 17.8558 4.0865 17.9135C4.14417 17.9712 4.21792 18 4.30775 18ZM9.8365 18H14.1635V6H9.8365V18ZM15.6635 18H19.6923C19.7821 18 19.8558 17.9712 19.9135 17.9135C19.9712 17.8558 20 17.7821 20 17.6923V6.30775C20 6.21792 19.9712 6.14417 19.9135 6.0865C19.8558 6.02883 19.7821 6 19.6923 6H15.6635V18ZM4.30775 19.5C3.80258 19.5 3.375 19.325 3.025 18.975C2.675 18.625 2.5 18.1974 2.5 17.6923V6.30775C2.5 5.80258 2.675 5.375 3.025 5.025C3.375 4.675 3.80258 4.5 4.30775 4.5H19.6923C20.1974 4.5 20.625 4.675 20.975 5.025C21.325 5.375 21.5 5.80258 21.5 6.30775V17.6923C21.5 18.1974 21.325 18.625 20.975 18.975C20.625 19.325 20.1974 19.5 19.6923 19.5H4.30775Z" fill="currentColor" />
                                </svg>
                            </button>
                            <div *ngIf="showEppRefDocColumnChooser"
                                 class="queues-column-chooser-dialog column-chooser-dialog">
                                <div class="queues-column-chooser-header">
                                    Column Chooser
                                    <button class="column-chooser-close"
                                            (click)="toggleEppRefDocColumnChooser()">&times;</button>
                                </div>
                                <div class="column-chooser-list font-14">
                                    <label *ngFor="let col of eppRefDocsGridConfig" class="column-chooser-checkbox">
                                        <input type="checkbox"
                                               [checked]="eppRefDocsVisibleColumns[col.columnDef]"
                                               [disabled]="col.disabled"
                                               (change)="onEppRefDocColumnToggle(col.columnDef, col.disabled)" />
                                        {{ col.header }}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="epp-ref-doc-grid-wrap">
                        <app-data-grid [config]="eppRefDocDataGridConfig" id="epp_ref_doc_grid_datagrid"
                              [statusDataField]="'template_status'"         [actionsTemplateRef]="eppRefDocActionsTemplate"></app-data-grid>
                    </div>

                    <ng-template #eppRefDocActionsTemplate let-row>
                        <div class="leadatactioncontainer">
                            <button class="action-icon-button download-btn" pTooltip="Download"
                                    tooltipPosition="top" tooltipStyleClass="pcustom-tooltip"
                                    (click)="onDownloadEppRefDoc({data: row})">
                                <span class="material-symbols-outlined">download</span>
                            </button>
                            <button *ngIf="row?.template_status?.toUpperCase() === 'INACTIVE'"
                                    class="action-icon-button activate-btn" pTooltip="Activate"
                                    tooltipPosition="top" tooltipStyleClass="pcustom-tooltip"
                                    (click)="activateEppRefDocPopup({data: row}, eppRefDocActivateModel, 'EPP')">
                                <span class="material-symbols-outlined">check_circle</span>
                            </button>
                            <button *ngIf="row?.template_status?.toUpperCase() === 'ACTIVE'"
                                    class="action-icon-button deletebtn" pTooltip="Deactivate"
                                    tooltipPosition="top" tooltipStyleClass="pcustom-tooltip"
                                    (click)="deactivateEppRefDocPopup({data: row}, eppRefDocDeactivateModel, 'EPP')">
                                <span class="material-symbols-outlined">unpublished</span>
                            </button>
                            <button class="action-icon-button deletebtn"
                                    pTooltip="Delete" tooltipPosition="top" tooltipStyleClass="pcustom-tooltip"
                                    (click)="onDeleteEppRefDocPopup({data: row}, eppRefDocDeleteModel, 'EPP')">
                                <span class="sr-only">Delete</span>
                                <span class="material-symbols-outlined material-delete-symbol">delete</span>
                            </button>
                        </div>
                    </ng-template>

                    <ng-template #eppRefDocStatusTemplate let-d>
                        <span class="status-badge" [ngClass]="{
                            'badge-active': d.value?.toLowerCase() === 'active',
                            'badge-inactive': d.value?.toLowerCase() === 'inactive'
                        }">
                            <span class="dot"></span>
                            {{ formatStatusText(d.value) }}
                        </span>
                    </ng-template>

                </div>
            </div>

        </p-accordionTab>

    </p-accordion>

    <!-- LEA Reference Documents Accordion -->
    <p-accordion class="custom-accordion">

        <p-accordionTab [header]="'LEA Reference Documents'">

            <div class="actions-bar">
                <div class="leadata-grid-table-container">

                    <div class="row row-alignment">
                        <button type="button" class="btn btn-primary grid rounded upload-btn mr-2" style="margin-right: 8px;"
                                (click)="showLeaRefDocUploadModal(leaRefDocUploadModel)">
                            <img class="mr-2 width-20" src="../../../../assets/images/neveda-images/upload.svg"
                                 alt="" srcset="">Upload
                        </button>

                        <div class="queues-export-btn-group">
                            <button mat-icon-button aria-label="Export" class="icon-btn" pTooltip="Export" tooltipPosition="top"
                                    tooltipStyleClass="pcustom-tooltip" (click)="exportLeaRefDocs()">
                                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none">
                                    <path d="M12 15.4115C11.8795 15.4115 11.7673 15.3923 11.6635 15.3538C11.5597 15.3154 11.4609 15.2494 11.3672 15.1558L8.25775 12.0463C8.10908 11.8974 8.03567 11.7233 8.0375 11.524C8.0395 11.3247 8.11292 11.1474 8.25775 10.9922C8.41292 10.8373 8.59108 10.7572 8.79225 10.752C8.99358 10.7468 9.17183 10.8218 9.327 10.977L11.25 12.9V5.25C11.25 5.03717 11.3218 4.859 11.4655 4.7155C11.609 4.57183 11.7872 4.5 12 4.5C12.2128 4.5 12.391 4.57183 12.5345 4.7155C12.6782 4.859 12.75 5.03717 12.75 5.25V12.9L14.673 10.977C14.8218 10.8283 14.9984 10.7549 15.2028 10.7568C15.4072 10.7588 15.5871 10.8373 15.7423 10.9922C15.8871 11.1474 15.9621 11.3231 15.9672 11.5192C15.9724 11.7154 15.8974 11.8911 15.7423 12.0463L12.6328 15.1558C12.5391 15.2494 12.4403 15.3154 12.3365 15.3538C12.2327 15.3923 12.1205 15.4115 12 15.4115ZM6.30775 19.5C5.80258 19.5 5.375 19.325 5.025 18.975C4.675 18.625 4.5 18.1974 4.5 17.6923V15.7308C4.5 15.5179 4.57183 15.3398 4.7155 15.1962C4.859 15.0526 5.03717 14.9808 5.25 14.9808C5.46283 14.9808 5.641 15.0526 5.7845 15.1962C5.92817 15.3398 6 15.5179 6 15.7308V17.6923C6 17.7692 6.03208 17.8398 6.09625 17.9038C6.16025 17.9679 6.23075 18 6.30775 18H17.6923C17.7692 18 17.8398 17.9679 17.9038 17.9038C17.9679 17.8398 18 17.7692 18 17.6923V15.7308C18 15.5179 18.0718 15.3398 18.2155 15.1962C18.359 15.0526 18.5372 14.9808 18.75 14.9808C18.9628 14.9808 19.141 15.0526 19.2845 15.1962C19.4282 15.3398 19.5 15.5179 19.5 15.7308V17.6923C19.5 18.1974 19.325 18.625 18.975 18.975C18.625 19.325 18.1974 19.5 17.6923 19.5H6.30775Z" fill="currentColor" />
                                </svg>
                            </button>
                        </div>

                        <div class="queues-column-chooser-group" style="margin-right: 8px;">
                            <button mat-icon-button  aria-label="Column Chooser" class="icon-btn" pTooltip="Column Chooser" tooltipPosition="top"
                                    tooltipStyleClass="pcustom-tooltip" (click)="toggleLeaRefDocColumnChooser()">
                                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none">
                                    <path d="M4.30775 18H8.3365V6H4.30775C4.21792 6 4.14417 6.02883 4.0865 6.0865C4.02883 6.14417 4 6.21792 4 6.30775V17.6923C4 17.7821 4.02883 17.8558 4.0865 17.9135C4.14417 17.9712 4.21792 18 4.30775 18ZM9.8365 18H14.1635V6H9.8365V18ZM15.6635 18H19.6923C19.7821 18 19.8558 17.9712 19.9135 17.9135C19.9712 17.8558 20 17.7821 20 17.6923V6.30775C20 6.21792 19.9712 6.14417 19.9135 6.0865C19.8558 6.02883 19.7821 6 19.6923 6H15.6635V18ZM4.30775 19.5C3.80258 19.5 3.375 19.325 3.025 18.975C2.675 18.625 2.5 18.1974 2.5 17.6923V6.30775C2.5 5.80258 2.675 5.375 3.025 5.025C3.375 4.675 3.80258 4.5 4.30775 4.5H19.6923C20.1974 4.5 20.625 4.675 20.975 5.025C21.325 5.375 21.5 5.80258 21.5 6.30775V17.6923C21.5 18.1974 21.325 18.625 20.975 18.975C20.625 19.325 20.1974 19.5 19.6923 19.5H4.30775Z" fill="currentColor" />
                                </svg>
                            </button>
                            <div *ngIf="showLeaRefDocColumnChooser"
                                 class="queues-column-chooser-dialog column-chooser-dialog">
                                <div class="queues-column-chooser-header">
                                    Column Chooser
                                    <button class="column-chooser-close"
                                            (click)="toggleLeaRefDocColumnChooser()">&times;</button>
                                </div>
                                <div class="column-chooser-list font-14">
                                    <label *ngFor="let col of leaRefDocsGridConfig" class="column-chooser-checkbox">
                                        <input type="checkbox"
                                               [checked]="leaRefDocsVisibleColumns[col.columnDef]"
                                               [disabled]="col.disabled"
                                               (change)="onLeaRefDocColumnToggle(col.columnDef, col.disabled)" />
                                        {{ col.header }}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="lea-ref-doc-grid-wrap">
                        <app-data-grid [config]="leaRefDocDataGridConfig" id="lea_ref_doc_grid_datagrid" [statusDataField]="'template_status'"
                                       [actionsTemplateRef]="leaRefDocActionsTemplate"></app-data-grid>
                    </div>

                    <ng-template #leaRefDocActionsTemplate let-row>
                        <div class="leadatactioncontainer">
                            <button class="action-icon-button download-btn" pTooltip="Download"
                                    tooltipPosition="top" tooltipStyleClass="pcustom-tooltip"
                                    (click)="onDownloadEppRefDoc({data: row})">
                                <span class="material-symbols-outlined">download</span>
                            </button>
                            <button *ngIf="row?.template_status?.toUpperCase() === 'INACTIVE'"
                                    class="action-icon-button activate-btn" pTooltip="Activate"
                                    tooltipPosition="top" tooltipStyleClass="pcustom-tooltip"
                                    (click)="activateEppRefDocPopup({data: row}, leaRefDocActivateModel, 'LEA')">
                                <span class="material-symbols-outlined">check_circle</span>
                            </button>
                            <button *ngIf="row?.template_status?.toUpperCase() === 'ACTIVE'"
                                    class="action-icon-button deletebtn" pTooltip="Deactivate"
                                    tooltipPosition="top" tooltipStyleClass="pcustom-tooltip"
                                    (click)="deactivateEppRefDocPopup({data: row}, leaRefDocDeactivateModel, 'LEA')">
                                <span class="material-symbols-outlined">unpublished</span>
                            </button>
                            <button class="action-icon-button deletebtn"
                                    pTooltip="Delete" tooltipPosition="top" tooltipStyleClass="pcustom-tooltip"
                                    (click)="onDeleteEppRefDocPopup({data: row}, leaRefDocDeleteModel, 'LEA')">
                                <span class="sr-only">Delete</span>
                                <span class="material-symbols-outlined material-delete-symbol">delete</span>
                            </button>
                        </div>
                    </ng-template>

                </div>
            </div>

        </p-accordionTab>

    </p-accordion>

</div>

<!-- LEA Reference Documents: Upload Modal -->
<ng-template #leaRefDocUploadModel let-modal>
  <form novalidate>
    <div class="upload-form-popup">
      <div class="form-modal-header p-4 d-flex justify-content-between">
        <h4 class="modal-title">Upload Files</h4>
        <button type="button" class="close" aria-label="Close" (click)="closeLeaRefDocUploadPopup()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="form-modal-body pl-4 pr-4 pt-4 pb-2">
        <div class="mb-3">
          <div class="lookup-education-upload-dropzone text-center p-4 rounded"
               (click)="leaRefDocFileInputRef.click()" (dragover)="$event.preventDefault()"
               (dragleave)="$event.preventDefault()" (drop)="onDropLeaRefDocFile($event)">
            <div class="upload-drop-content">
              <span class="p-button-icon p-button-icon-left pi pi-upload upload"></span>
              <span>Drag &amp; drop or <span class="choose-file-link">choose a file</span> to upload</span>
            </div>
            <input type="file" #leaRefDocFileInputRef class="file-input-hidden"
                   (click)="clearLeaRefDocFileInput($event)"
                   (change)="handleLeaRefDocFileUpload($event)" accept=".xlsx,.xls,.jpg,.jpeg,.png,.pdf" />
          </div>
          <div class="no-file-uploaded mt-20"
               [ngClass]="!leaRefDocUploadData.file ? 'no-file-uploaded border-0' : ''">
            <i *ngIf="!leaRefDocUploadData.file" class="pi pi-file"></i>
            <span *ngIf="leaRefDocUploadData.file" class="text-left border-0">{{ leaRefDocUploadData.file.name }}</span>
            <span *ngIf="!leaRefDocUploadData.file">No file uploaded</span>
          </div>
          <div *ngIf="leaRefDocUploadError" class="text-danger small mt-2">{{ leaRefDocUploadError }}</div>
          <div *ngIf="leaRefDocOneFileIsRequired" class="text-danger small mt-2">Please select a file.</div>
        </div>
        <div class="mb-3 filedetails">
          <p class="filesformat">Supported formats: Excel, JPEG, JPG, PNG, PDF.</p>
          <p class="filesformat">Maximum size: 15 MB.</p>
        </div>
      </div>
      <div class="form-modal-footer p-3 d-flex">
        <button type="button" class="btn-cancel btn btn-md px-3 py-1"
                (click)="closeLeaRefDocUploadPopup()">Cancel</button>
        <button lang="en" class="btn btn-primary btn-md rounded ms-2" type="button"
                [disabled]="leaRefDocSaveEnable" (click)="onSaveLeaRefDoc()">Save</button>
      </div>
    </div>
  </form>
</ng-template>

<!-- LEA Reference Documents: Activate Modal -->
<ng-template #leaRefDocActivateModel let-modal>
    <div class="form-modal-header p-3 d-flex justify-content-between align-items-center">
        <h4 class="form-modal-title">Activate Reference Document</h4>
        <button type="button" class="close" aria-label="Close" (click)="closePopup()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="form-modal-body p-3">
        <p class="delete-content">Are you sure you want to activate
            <b>{{ selectedEppRefDocRow?.file_name }}</b>?<br/>
            Once activated, this reference document will be available for download.
        </p>
    </div>
    <div class="form-modal-footer p-3">
        <div class="justify-content-center modal-actions">
            <button class="btn-cancel btn btn-md px-3 py-1" (click)="modalStatusClose()">Cancel</button>
            <button lang="en" class="btn btn-md deletebtn" (click)="activateEppRefDoc()">Proceed</button>
        </div>
    </div>
</ng-template>

<!-- LEA Reference Documents: Deactivate Modal -->
<ng-template #leaRefDocDeactivateModel let-modal>
    <div class="form-modal-header p-3 d-flex justify-content-between align-items-center">
        <h4 class="form-modal-title">Deactivate Reference Document</h4>
        <button type="button" class="close" aria-label="Close" (click)="closePopup()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="form-modal-body p-3">
        <p class="delete-content">Are you sure you want to deactivate
            <b>{{ selectedEppRefDocRow?.file_name }}</b>?<br/>
            Once deactivated, this template will no longer be available for download.
        </p>
    </div>
    <div class="form-modal-footer p-3">
        <div class="justify-content-center modal-actions">
            <button class="btn-cancel btn btn-md px-3 py-1" (click)="modalStatusClose()">Cancel</button>
            <button lang="en" class="btn btn-md deletebtn" (click)="deactivateEppRefDoc()">Proceed</button>
        </div>
    </div>
</ng-template>

<!-- LEA Reference Documents: Delete Modal -->
<ng-template #leaRefDocDeleteModel let-modal>
    <div class="form-modal-header p-3 d-flex justify-content-between align-items-center">
        <h4 class="form-modal-title">Delete Reference Document</h4>
        <button type="button" class="close" aria-label="Close" (click)="closePopup()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="form-modal-body p-3">
        <p class="delete-content">Are you sure you want to delete this document?<br/>
            This action cannot be undone.
        </p>
    </div>
    <div class="form-modal-footer p-3">
        <div class="justify-content-center modal-actions">
            <button class="btn-cancel btn btn-md px-3 py-1" (click)="modalStatusClose()">Cancel</button>
            <button lang="en" class="btn btn-md deletebtn" (click)="deleteEppRefDoc()">Delete</button>
        </div>
    </div>
</ng-template>

<ng-template #deleteModel let-modal>
    <div class="form-modal-header p-3 d-flex justify-content-between align-items-center">
        <h4 class="form-modal-title">Activate Template</h4>
        <button type="button" class="close" aria-label="Close" (click)="closePopup()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="form-modal-body p-3">
        <p class="delete-content">Are you sure you want to activate <b>{{template_name}}?</b>
            Once activated, this template will be available for download and data submission.</p>
    </div>
    <div class="form-modal-footer p-3">
        <div class="justify-content-center modal-actions">
            <button class="btn-cancel btn  btn-md px-3 py-1" (click)="modalStatusClose()">Cancel</button>
            <button lang="en" class="btn  btn-md deletebtn " (click)="activateLeaTemplate()"
                ref="button">Proceed</button>
        </div>
    </div>
</ng-template>

<ng-template #deleteModel1 let-modal>
    <div class="form-modal-header p-3 d-flex justify-content-between align-items-center">
        <h4 class="form-modal-title">Deactivate Template</h4>
        <button type="button" class="close" aria-label="Close" (click)="closePopup()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="form-modal-body p-3">
        <p class="delete-content">Are you sure you want to deactivate <b>{{template_name}}?</b>
            Once deactivated, this template will no longer be available for download or data submission.</p>
    </div>
    <div class="form-modal-footer p-3">
        <div class="justify-content-center modal-actions">
            <button class="btn-cancel btn  btn-md px-3 py-1" (click)="modalStatusClose()">Cancel</button>
            <button lang="en" class="btn  btn-md deletebtn " (click)="deactivateLeaTemplate()"
                ref="button">Proceed</button>
        </div>
    </div>
</ng-template>

<ng-template #deleteModel2 let-modal>
    <div class="form-modal-header p-3 d-flex justify-content-between align-items-center">
        <h4 class="form-modal-title">Delete Record</h4>
        <button type="button" class="close" aria-label="Close" (click)="closePopup()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="form-modal-body p-3">
        <p class="delete-content">Are you sure you want to delete this record?
            This action cannot be undone.</p>
    </div>
    <div class="form-modal-footer p-3">
        <div class="justify-content-center modal-actions">
            <button class="btn-cancel btn  btn-md px-3 py-1" (click)="modalStatusClose()">Cancel</button>
            <button lang="en" class="btn  btn-md deletebtn " (click)="deleteRow()" ref="button">Delete</button>
        </div>
    </div>
</ng-template>


<!--  -->

<ng-template #deleteModelEpp let-modal>
    <div class="form-modal-header p-3 d-flex justify-content-between align-items-center">
        <h4 class="form-modal-title">Activate Template</h4>
        <button type="button" class="close" aria-label="Close" (click)="closePopup()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="form-modal-body p-3">
        <p class="delete-content">Are you sure you want to activate <b>{{template_name}}?</b>
            Once activated, this template will be available for download and data submission.</p>
    </div>
    <div class="form-modal-footer p-3">
        <div class="justify-content-center modal-actions">
            <button class="btn-cancel btn  btn-md px-3 py-1" (click)="modalStatusClose()">Cancel</button>
            <button lang="en" class="btn  btn-md deletebtn " (click)="activateEppTemplate()"
                ref="button">Proceed</button>
        </div>
    </div>
</ng-template>

<ng-template #deleteModel1Epp let-modal>
    <div class="form-modal-header p-3 d-flex justify-content-between align-items-center">
        <h4 class="form-modal-title">Deactivate Template</h4>
        <button type="button" class="close" aria-label="Close" (click)="closePopup()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="form-modal-body p-3">
        <p class="delete-content">Are you sure you want to deactivate <b>{{template_name}}?</b>
            Once deactivated, this template will no longer be available for download or data submission.</p>
    </div>
    <div class="form-modal-footer p-3">
        <div class="justify-content-center modal-actions">
            <button class="btn-cancel btn  btn-md px-3 py-1" (click)="modalStatusClose()">Cancel</button>
            <button lang="en" class="btn  btn-md deletebtn " (click)="deactivateEppTemplate()"
                ref="button">Proceed</button>
        </div>
    </div>
</ng-template>

<!-- EPP Reference Documents: Upload Modal -->
<ng-template #eppRefDocUploadModel let-modal>
  <form novalidate>
    <div class="upload-form-popup">
      <div class="form-modal-header p-4 d-flex justify-content-between">
        <h4 class="modal-title">Upload Files</h4>
        <button type="button" class="close" aria-label="Close" (click)="closeEppRefDocUploadPopup()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="form-modal-body pl-4 pr-4 pt-4 pb-2">
        <div class="mb-3">
          <div class="lookup-education-upload-dropzone text-center p-4 rounded"
               (click)="eppRefDocFileInputRef.click()" (dragover)="$event.preventDefault()"
               (dragleave)="$event.preventDefault()" (drop)="onDropEppRefDocFile($event)">
            <div class="upload-drop-content">
              <span class="p-button-icon p-button-icon-left pi pi-upload upload"></span>
              <span>Drag &amp; drop or <span class="choose-file-link">choose a file</span> to upload</span>
            </div>
            <input type="file" #eppRefDocFileInputRef class="file-input-hidden"
                   (click)="clearEppRefDocFileInput($event)"
                   (change)="handleEppRefDocFileUpload($event)" accept=".xlsx,.xls,.jpg,.jpeg,.png,.pdf" />
          </div>
          <div class="no-file-uploaded mt-20"
               [ngClass]="!eppRefDocUploadData.file ? 'no-file-uploaded border-0' : ''">
            <i *ngIf="!eppRefDocUploadData.file" class="pi pi-file"></i>
            <span *ngIf="eppRefDocUploadData.file" class="text-left border-0">{{ eppRefDocUploadData.file.name }}</span>
            <span *ngIf="!eppRefDocUploadData.file">No file uploaded</span>
          </div>
          <div *ngIf="eppRefDocUploadError" class="text-danger small mt-2">{{ eppRefDocUploadError }}</div>
          <div *ngIf="eppRefDocOneFileIsRequired" class="text-danger small mt-2">Please select a file.</div>
        </div>
        <div class="mb-3 filedetails">
          <p class="filesformat">Supported formats: Excel, JPEG, JPG, PNG, PDF.</p>
          <p class="filesformat">Maximum size: 15 MB.</p>
        </div>

      </div>
      <div class="form-modal-footer p-3 d-flex">
        <button type="button" class="btn-cancel btn btn-md px-3 py-1"
                (click)="closeEppRefDocUploadPopup()">Cancel</button>
        <button lang="en" class="btn btn-primary btn-md rounded ms-2" type="button"
                [disabled]="eppRefDocSaveEnable" (click)="onSaveEppRefDoc()">Save</button>
      </div>
    </div>
  </form>
</ng-template>

<!-- EPP Reference Documents: Activate Modal -->
<ng-template #eppRefDocActivateModel let-modal>
    <div class="form-modal-header p-3 d-flex justify-content-between align-items-center">
        <h4 class="form-modal-title">Activate Reference Document</h4>
        <button type="button" class="close" aria-label="Close" (click)="closePopup()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="form-modal-body p-3">
        <p class="delete-content">Are you sure you want to activate
            <b>{{ selectedEppRefDocRow?.file_name }}</b>?<br/>
            Once activated, this reference document will be available for download.
        </p>
    </div>
    <div class="form-modal-footer p-3">
        <div class="justify-content-center modal-actions">
            <button class="btn-cancel btn btn-md px-3 py-1" (click)="modalStatusClose()">Cancel</button>
            <button lang="en" class="btn btn-md deletebtn" (click)="activateEppRefDoc()">Proceed</button>
        </div>
    </div>
</ng-template>

<!-- EPP Reference Documents: Deactivate Modal -->
<ng-template #eppRefDocDeactivateModel let-modal>
    <div class="form-modal-header p-3 d-flex justify-content-between align-items-center">
        <h4 class="form-modal-title">Deactivate Reference Document</h4>
        <button type="button" class="close" aria-label="Close" (click)="closePopup()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="form-modal-body p-3">
        <p class="delete-content">Are you sure you want to deactivate
            <b>{{ selectedEppRefDocRow?.file_name }}</b>?<br/>
            Once deactivated, this template will no longer be available for download.
        </p>
    </div>
    <div class="form-modal-footer p-3">
        <div class="justify-content-center modal-actions">
            <button class="btn-cancel btn btn-md px-3 py-1" (click)="modalStatusClose()">Cancel</button>
            <button lang="en" class="btn btn-md deletebtn" (click)="deactivateEppRefDoc()">Proceed</button>
        </div>
    </div>
</ng-template>

<!-- EPP Reference Documents: Delete Modal -->
<ng-template #eppRefDocDeleteModel let-modal>
    <div class="form-modal-header p-3 d-flex justify-content-between align-items-center">
        <h4 class="form-modal-title">Delete Reference Document</h4>
        <button type="button" class="close" aria-label="Close" (click)="closePopup()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="form-modal-body p-3">
        <p class="delete-content">Are you sure you want to delete this document?<br/>
            This action cannot be undone.
        </p>
    </div>
    <div class="form-modal-footer p-3">
        <div class="justify-content-center modal-actions">
            <button class="btn-cancel btn btn-md px-3 py-1" (click)="modalStatusClose()">Cancel</button>
            <button lang="en" class="btn btn-md deletebtn" (click)="deleteEppRefDoc()">Delete</button>
        </div>
    </div>
</ng-template>